import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "dnilasor_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setAdminToken = (token) => localStorage.setItem(ADMIN_TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

export const fetchCatalog = async () => (await api.get("/catalog")).data;
export const fetchOffering = async (slug) => (await api.get(`/catalog/${slug}`)).data;
export const fetchAvailability = async (date) =>
  (await api.get(`/availability`, { params: { date } })).data;
export const createCheckout = async (payload) =>
  (await api.post(`/bookings/checkout`, payload)).data;
export const fetchBookingStatus = async (sessionId) =>
  (await api.get(`/bookings/status/${sessionId}`)).data;
export const fetchBookings = async (status) =>
  (await api.get(`/bookings`, { params: status ? { status } : {} })).data;

export const adminLogin = async (password) =>
  (await api.post(`/admin/login`, { password })).data;
export const adminVerify = async () => (await api.get(`/admin/verify`)).data;

export const formatUSD = (amount) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(amount);
